export const ORGANISATION_PROFILE_PATH_SEGMENT = 'organisations/organisation-profile';
export const ORGANISATION_SETTINGS_PATH_SEGMENT = '/organisation-settings';
